/**
 *
 *@author xujinjiang
 *@date 2022/3/30 13:15
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { ref, watch } from 'vue';
import router from '@/router';
import { ObserverService } from '@/service/ObserverService';
import { LocalStorageManager } from '@/db/LocalStorageManager';
import { LocalStorageKey } from '@/constant/LocalStorageKey';
import { RouterUtil } from '@/utils/RouterUtil';
export class WebsiteViewModel extends BaseViewModel {
  headSubscription: any;
  isLoginSubscription: any;
  needWhiteHeader = false;
  isLogin = false;
  showPhoneHeader = false;
  isScroll = false;
  drawer: any = ref(false);
  selectDoc = false;
  goHome = false;

  created() {
    // 初始化观察者服务
    ObserverService.getInstance().init();
  }

  mounted() {
    this.initObserver();
    this.watchWindowFocus();
    this.watchWindowWith();
    this.getRoute();
    this.watchRoute();
    this.watchRouteHash();
    const token: any = LocalStorageManager.getItem(LocalStorageKey.token);
    const userInfo = LocalStorageManager.getUser();
    if (userInfo && token) {
      this.isLogin = true;
    }
    if (!userInfo || !token) {
      this.isLogin = false;
    }
  }

  /**
   * 监听是否点击tab进入此窗口
   */
  watchWindowFocus() {
    window.addEventListener(
      'focus',
      () => {
        const token: any = LocalStorageManager.getItem(LocalStorageKey.token);
        const userInfo = LocalStorageManager.getUser();
        if (userInfo && token) {
          this.isLogin = true;
          return;
        }
        if (!userInfo || !token) {
          this.isLogin = false;
        }
      },
      true
    );
  }
  /**
   * 监听窗口宽度
   */
  watchWindowWith() {
    if (window.innerWidth <= 735) {
      this.showPhoneHeader = true;
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 735) {
        this.showPhoneHeader = true;
      }
      if (window.innerWidth > 735) {
        this.showPhoneHeader = false;
        this.drawer = false;
      }
    });
  }

  /**
   * 监听路由
   */
  watchRoute() {
    watch(
      () => router.currentRoute.value.path,
      (newValue: any, oldValue: any) => {
        if (newValue === '/website/doc') {
          this.needWhiteHeader = true;
          this.selectDoc = true;
          return;
        }
        this.needWhiteHeader = false;
        this.selectDoc = false;
      }
    );
  }

  /**
   * 监听路由参数
   */
  watchRouteHash() {
    watch(
      () => router.currentRoute.value.hash,
      (newValue: any, oldValue: any) => {
        if (newValue === '#apply') {
          this.$nextTick(() => {
            const el = document.querySelector('#applyDeveloper') as any;
            const websiteHome = document.querySelector('.website-home') as any;
            websiteHome.scrollTop = el.offsetTop;
          }).then();
        }
      }
    );
  }
  /**
   * 获取路由
   */
  getRoute() {
    const route = this.$route.path;
    if (route === '/website/doc') {
      this.needWhiteHeader = true;
      this.selectDoc = true;
      return;
    }
    this.needWhiteHeader = false;
    this.selectDoc = false;
  }

  unmounted() {
    if (this.headSubscription) {
      this.headSubscription.unsubscribe();
    }
    if (this.isLoginSubscription) {
      this.isLoginSubscription.unsubscribe();
    }
  }

  private initObserver() {
    this.headSubscription = ObserverService.getInstance()
      .getShowWhiteHeadObserver()
      .subscribe((isScroll: boolean) => {
        if (isScroll === null) {
          return;
        }
        this.isScroll = isScroll;
        this.goHome = false;
      });
    this.isLoginSubscription = ObserverService.getInstance()
      .getIsLoginObserver()
      .subscribe((isLogin: boolean) => {
        if (isLogin === null) {
          return;
        }
        this.isLogin = isLogin;
      });
  }

  /**
   * 回到首页
   */
  home() {
    this.goHome = true;
    this.drawer = false;
    this.$router.push('/website/home').then();
  }

  /**
   * 打开开发者与帮助文档
   */
  openDoc() {
    this.needWhiteHeader = true;
    this.drawer = false;
    RouterUtil.openDoc(this.$router);
  }

  /**
   * 登录（若已登陆点击进入管理平台）
   */
  login() {
    if (!this.isLogin) {
      this.drawer = false;
      (this.$refs.login as any).dialogVis(true);
      return;
    }
    const userInfo = LocalStorageManager.getUser();
    const token: any = LocalStorageManager.getItem(LocalStorageKey.token);
    const { href } = router.resolve({
      path: '/cms/home',
      query: {
        id: (userInfo as any).id,
        token: token
      }
    });
    window.open(href);
  }

  /**
   * 显示抽屉效果的导航栏
   */
  showDrawer() {
    this.drawer = true;
  }
}
